import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af46b7ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "main-banner-area",
  class: "position-relative"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slider" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tp-bullets numbered vertical nav-pos-hor-left nav-pos-ver-center nav-dir-vertical white",
  style: {"height":"55px","width":"15.3167px","top":"50%","transform":"matrix(1, 0, 0, 1, 20, -27)","left":"0px"}
}, null, -1))
const _hoisted_4 = { class: "social-icons-simple revicon white" }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<section id=\"about\" class=\"single-feature padding mt-n5\" data-v-af46b7ba><div class=\"container\" data-v-af46b7ba><div class=\"row\" data-v-af46b7ba><div class=\"col-md-12\" data-v-af46b7ba><div class=\"row d-flex align-items-center\" data-v-af46b7ba><div class=\"col-lg-6 text-sm-left text-center wow fadeInLeft\" data-wow-delay=\"300ms\" data-v-af46b7ba><div class=\"heading-title mb-4\" data-v-af46b7ba><h2 class=\"darkcolor font-normal bottom30\" data-v-af46b7ba><span class=\"defaultcolor\" data-v-af46b7ba> Keterangan Umum </span><br data-v-af46b7ba> Permohonan Surat Keterangan </h2></div><p class=\"bottom35\" data-v-af46b7ba> Kewajiban Perizinan Berusaha penyediaan tenaga listrik untuk kepentingan sendiri dengan total kapasitas pembangkit tenaga listrik sampai dengan 50O kW (lima ratus kilowatt) yang terhubung dalam 1 (satu) sistem Instalasi Tenaga Listrik berupa penyampaian laporan sebanyak I (satu) kali kepada Menteri atau gubernur sebelum melakukan Usaha Penyediaan Tenaga Listrik untuk kepentingan sendiri. </p></div><div class=\"col-lg-6 wow fadeInRight\" data-wow-delay=\"300ms\" data-v-af46b7ba><div class=\"image float-right\" data-v-af46b7ba><img alt=\"\" src=\"images/bg-about.png\" data-v-af46b7ba></div></div></div></div></div></div></section><section id=\"bg-counters\" class=\"padding bg-counters parallax\" data-v-af46b7ba><div class=\"container\" data-v-af46b7ba><div class=\"row align-items-center text-center\" data-v-af46b7ba><div class=\"overlay overlay-dark opacity-1 z-index-0\" data-v-af46b7ba></div><div class=\"col-lg-12 col-md-12 col-sm-12 bottom10\" data-v-af46b7ba><div class=\"container\" data-v-af46b7ba><div class=\"row text-center justify-content-center mb-5\" data-v-af46b7ba><div class=\"col-xl-6 col-lg-8\" data-v-af46b7ba><h3 class=\"font-weight-bold text-white\" data-v-af46b7ba>Alur Proses</h3><p class=\"text-white\" data-v-af46b7ba>Permohonan Dukungan Daya</p></div></div><div class=\"row\" data-v-af46b7ba><div class=\"col\" data-v-af46b7ba><div class=\"timeline-steps aos-init aos-animate\" data-aos=\"fade-up\" data-v-af46b7ba><div class=\"timeline-step text-white\" data-v-af46b7ba><div class=\"timeline-content\" data-toggle=\"popover\" data-trigger=\"hover\" data-placement=\"top\" title=\"\" data-content=\"And here&#39;s some amazing content. It&#39;s very engaging. Right?\" data-original-title=\"2003\" data-v-af46b7ba><div class=\"inner-circle\" data-v-af46b7ba></div><p class=\"h5 mt-3 mb-1\" data-v-af46b7ba>1</p><p class=\"h5 text-white mb-0 mb-lg-0\" data-v-af46b7ba> Pengajuan Permohonan </p></div></div><div class=\"timeline-step text-white\" data-v-af46b7ba><div class=\"timeline-content\" data-toggle=\"popover\" data-trigger=\"hover\" data-placement=\"top\" title=\"\" data-content=\"And here&#39;s some amazing content. It&#39;s very engaging. Right?\" data-original-title=\"2004\" data-v-af46b7ba><div class=\"inner-circle\" data-v-af46b7ba></div><p class=\"h5 mt-3 mb-1\" data-v-af46b7ba>2</p><p class=\"h5 text-white mb-0 mb-lg-0\" data-v-af46b7ba> Verifikasi Verifikator </p></div></div><div class=\"timeline-step text-white\" data-v-af46b7ba><div class=\"timeline-content\" data-toggle=\"popover\" data-trigger=\"hover\" data-placement=\"top\" title=\"\" data-content=\"And here&#39;s some amazing content. It&#39;s very engaging. Right?\" data-original-title=\"2005\" data-v-af46b7ba><div class=\"inner-circle\" data-v-af46b7ba></div><p class=\"h5 mt-3 mb-1\" data-v-af46b7ba>3</p><p class=\"h5 text-white mb-0 mb-lg-0\" data-v-af46b7ba>Verifikasi Kabid</p></div></div><div class=\"timeline-step text-white\" data-v-af46b7ba><div class=\"timeline-content\" data-toggle=\"popover\" data-trigger=\"hover\" data-placement=\"top\" title=\"\" data-content=\"And here&#39;s some amazing content. It&#39;s very engaging. Right?\" data-original-title=\"2005\" data-v-af46b7ba><div class=\"inner-circle\" data-v-af46b7ba></div><p class=\"h5 mt-3 mb-1\" data-v-af46b7ba>4</p><p class=\"h5 text-white mb-0 mb-lg-0\" data-v-af46b7ba> Verifikasi Kadis &amp; TTE Kadis </p></div></div><div class=\"timeline-step text-white\" data-v-af46b7ba><div class=\"timeline-content\" data-toggle=\"popover\" data-trigger=\"hover\" data-placement=\"top\" title=\"\" data-content=\"And here&#39;s some amazing content. It&#39;s very engaging. Right?\" data-original-title=\"2005\" data-v-af46b7ba><div class=\"inner-circle\" data-v-af46b7ba></div><p class=\"h5 mt-3 mb-1\" data-v-af46b7ba>5</p><p class=\"h5 text-white mb-0 mb-lg-0\" data-v-af46b7ba>Selesai</p></div></div></div></div></div></div></div></div></div></section>", 2)
const _hoisted_8 = {
  id: "our-blog",
  class: "bglight padding_top padding_bottom_half",
  style: {"background-image":"url('fe/asset/img/big-bg-white.png')","background-size":"cover","border-radius":"10px !important"}
}
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "news_item shadow-equal" }
const _hoisted_13 = {
  class: "news_desc text-center text-md-left",
  style: {"background-color":"#fff !important","background-image":"none !important"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-0 mb-5" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-dark" }, "Dasar Hukum")
], -1))
const _hoisted_15 = { class: "mt-5" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, null, -1))
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Semua Tahun", -1))
const _hoisted_21 = ["value"]
const _hoisted_22 = ["href"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-down-fill" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_b_overlay = _resolveComponent("b-overlay")!
  const _directive_debounce = _resolveDirective("debounce")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSocialMedia, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "d-table",
            key: index
          }, [
            _createElementVNode("a", {
              href: item.url,
              class: ""
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(item.icon)
              }, null, 2)
            ], 8, _hoisted_5)
          ]))
        }), 128))
      ])
    ]),
    _hoisted_6,
    _createElementVNode("section", _hoisted_8, [
      _createVNode(_component_b_overlay, {
        show: false,
        rounded: "sm"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                            class: "form-control form-control-solid w-250px ps-15",
                            placeholder: "Cari..."
                          }, null, 512), [
                            [_vModelText, _ctx.search],
                            [_directive_debounce, _ctx.searchItems, "200ms"]
                          ])
                        ]),
                        _hoisted_18,
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("select", {
                            name: "",
                            class: "form-control",
                            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleTahunChange($event)))
                          }, [
                            _hoisted_20,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTahun, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: item,
                                value: item
                              }, _toDisplayString(item), 9, _hoisted_21))
                            }), 128))
                          ], 32)
                        ])
                      ]),
                      _createVNode(_component_Datatable, {
                        onOnSort: _ctx.sort,
                        onOnItemsPerPageChange: _ctx.itemsPerPageChange,
                        onPageChange: _ctx.pageChange,
                        data: _ctx.rulesList,
                        header: _ctx.tableHeader,
                        "enable-items-per-page-dropdown": true,
                        total: _ctx.rulesMeta.total_data,
                        itemsPerPage: 10,
                        "empty-table-text": "Tidak ada data"
                      }, {
                        id: _withCtx(({ row }) => [
                          _createTextVNode(_toDisplayString(_ctx.rulesList.indexOf(row) +
                        1 +
                        (_ctx.rulesMeta.page - 1) * _ctx.rulesMeta.limit) + ". ", 1)
                        ]),
                        tahun_terbit: _withCtx(({ row: rulesList }) => [
                          _createTextVNode(_toDisplayString(rulesList.tahun_terbit), 1)
                        ]),
                        title: _withCtx(({ row: rulesList }) => [
                          _createTextVNode(_toDisplayString(rulesList.title), 1)
                        ]),
                        actions: _withCtx(({ row: rulesList }) => [
                          _createElementVNode("a", {
                            target: "_blank",
                            href: _ctx.getFilePath('rules-doc', rulesList.document),
                            class: "btn btn-sm btn-secondary"
                          }, [
                            _hoisted_23,
                            _createTextVNode(" Download PDF ")
                          ], 8, _hoisted_22)
                        ]),
                        _: 1
                      }, 8, ["onOnSort", "onOnItemsPerPageChange", "onPageChange", "data", "header", "total"])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ])
  ], 64))
}